import { EventSlot } from "../../events/EventSlot";
import { PHPContext } from "../PHPContext";
import { RemoveFromCartRequest } from "./RemoveFromCartRequest";
import { AddItemToCartRequest } from "./AddItemToCartRequest";
import { CartEntry } from "./CartEntry";
import { CartListItemsRequest } from "./CartListItemsRequest";
import { CartItemInput } from "./CartItemInput";
import { CartListInput } from "./CartListInput";
import { HideToCartQuestionRequest } from "./HideToCartQuestionRequest";
import { GetHideToCartQuestionRequest } from "./GetHideToCartQuestionRequest";

import { BoolInput } from "../input/BoolInput";
import { EmptyInput } from "../input/EmptyInput";

export class Cart
{
  readonly wishlistChanged:EventSlot<CartEntry[]> = new EventSlot<CartEntry[]>();
  readonly productsChanges:EventSlot<CartEntry[]> = new EventSlot<CartEntry[]>();
  
  get phpContext():PHPContext
  {
    return null; 
  }

  async addItem( id:string, wishlist:boolean ):Promise<CartEntry[]>
  {
    let addItemToCart = new AddItemToCartRequest();
    let input = new CartItemInput();
    input.id = id;
    input.wishlist = wishlist;

    let result = await addItemToCart.request( this.phpContext, input );

    if ( result.error )
    {
      return Promise.reject( result );
    }

    if ( wishlist )
    {
      this.wishlistChanged.dispatch( result.entries );
    }
    else
    {
      this.productsChanges.dispatch( result.entries );
    }

    return Promise.resolve( result.entries );
  }

  async removeItem( id:string, wishlist:boolean ):Promise<CartEntry[]>
  {
    let removeItemFromCart = new RemoveFromCartRequest();
    let input = new CartItemInput();
    input.id = id;
    input.wishlist = wishlist;

    let result = await removeItemFromCart.request( this.phpContext, input );

    if ( result.error )
    {
      return Promise.reject( result );
    }

    if ( wishlist )
    {
      this.wishlistChanged.dispatch( result.entries );
    }
    else
    {
      this.productsChanges.dispatch( result.entries );
    }

    return Promise.resolve( result.entries );
  }

  async getItems( wishlist:boolean):Promise<CartEntry[]>
  {
    let getItems = new CartListItemsRequest();

    let input = new CartListInput();
    input.wishlist = wishlist;

    let result = await getItems.request( this.phpContext, input );

    if ( result.error )
    {
      return Promise.reject( result );
    }

    return Promise.resolve( result.entries );
  }

  async getHideToCartQuestion()
  {
    let request = new GetHideToCartQuestionRequest();

    let input = new EmptyInput();

    let result = await request.request( this.phpContext, input );

    if ( result.error )
    {
      return Promise.reject( result );
    }

    return Promise.resolve( result.value );
  }

  async setHideToCartQuestion( enabled:boolean )
  {
    let request = new HideToCartQuestionRequest();

    let input = new BoolInput();
    input.value = enabled;

    let result = await request.request( this.phpContext, input );

    if ( result.error )
    {
      return Promise.reject( result );
    }

    return Promise.resolve();
  }

}